export default "__VITE_ASSET__4ce16b23__"